module.exports = __webpack_public_path__ + "img/Logo_fiponline_big.760268de.png";